export default __webpack_public_path__ + "static/media/svg-3.e1e9e785.svg";